import type { UserItem, UserListResponse } from "./types"

interface UserDataResponse {
    data: {
        department: string
        departmentUuid: string
        status: string
    }
}

// format User list
export function formatUserList(response: UserListResponse): UserItem[] {
    return response.results
}

// format user data response 讓用戶資訊符合 routerProtect 需要的格式。
export function formatUserDataToRouterProtectStyle(userDataResponse: UserDataResponse) {
    const result = {
        data: {
            creator: {
                department: {
                    name: userDataResponse.data.department,
                    uuid: userDataResponse.data.departmentUuid,
                },
                name: "",
                role: {
                    name: "",
                    slug: "",
                    level: "",
                },
                uuid: "",
            },
            status: userDataResponse.data.status,
        },
    }
    return result
}
